import React from "react";

import { css } from "@emotion/core";

import { Button } from "@zapier/design-system";

import {
  OverdueInvoice,
  PaymentSource,
  PaymentSourceType,
  SupportedPaymentMethod,
} from "../../types";
import PaymentMethodSelect from "./PaymentMethodSelect";

interface Props {
  isEditing: boolean;
  savedSource: PaymentSource | null;
  onEdit: () => void;
  overdueInvoice?: OverdueInvoice;
  hideSwitch: boolean;
  currentMethod: PaymentSourceType | null;
  onSelectSource: (method: PaymentSourceType) => void;
  switchMethodOptions: SupportedPaymentMethod[];
}

const buttonGroupCss = css`
  display: flex;
  gap: 16px;
`;
export const Aside = (props: Props) => {
  if (!props.isEditing) {
    return (
      <div css={buttonGroupCss}>
        <Button
          ariaLabel={
            props.savedSource
              ? "Edit payment information"
              : "Add payment information"
          }
          color="secondary"
          onClick={props.onEdit}
          size="small"
        >
          {props.savedSource ? "Edit payment information" : "Add"}
        </Button>
        {Boolean(props.overdueInvoice) && (
          <Button color="danger" href="/app/checkout/invoice/pay" size="small">
            Pay invoice
          </Button>
        )}
      </div>
    );
  }

  if (props.hideSwitch) return null;

  return (
    <PaymentMethodSelect
      currentMethod={props.currentMethod}
      onChange={props.onSelectSource}
      supportedMethods={props.switchMethodOptions}
    />
  );
};
